import React from 'react';
import "./judgmentsData.css";

const JudgmentsData = (props) => {
    const judgmentsData = props.judgmentsList.map(judgment=> (
        <>
            <tr key={judgment.id}>
                    <td>
                        {judgment.date}
                    </td>
                    <td>
                        {judgment.signature}
                    </td>
                    <td>
                        {judgment.court}
                    </td>
                    <td>
                        {judgment.bank}
                    </td>
                    <td>
                        {judgment.note}
                    </td>
                    <td>
                        <button className="actionButtonTable" value={judgment.id} onClick={props.handleDeleteJudgment}>Usuń</button>
                    </td>
            </tr>
        </>
    ))

    return ( 
        <>
            <div className="tableRow">
                <table className="judgmentsTable">
                    <tbody>
                        <tr>
                            <th>Data</th>
                            <th>Sygnatura</th>
                            <th>Sąd</th>
                            <th>Bank</th>
                            <th>Notatka</th>
                            <th>Akcja</th>
                        </tr>
                        {judgmentsData}
                    </tbody>
                </table> 
            </div>  
        </>
    );
}
 
export default JudgmentsData;